module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"company":"Unternehmen"},"en":{"company":"Company"}}')
  delete Component.options._Ctor
}
